module.exports = __webpack_public_path__ + "static/media/text-link-generic.afc4646f.svg";